import type { Edge } from 'reactflow';

export enum LinkType {
  Hierarchy = 'Hierarchy',
  Dependency = 'Dependency',
  Contribution = 'Contribution',
  Contradiction = 'Contradiction',
  Complementarity = 'Complementarity',
  FreeForm = 'FreeForm',
}

export enum LinkIntensity {
  Strong = 'Strong',
  Medium = 'Medium',
  Weak = 'Weak',
}

export interface LinkData {
  linkType: LinkType;
  intensity: LinkIntensity;
  label?: string;
  description?: string;
  canvasId: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export type StratMapEdge = Edge<LinkData>;

export interface CreateLinkPayload {
  sourceNodeId: string;
  targetNodeId: string;
  type: LinkType;
  intensity?: LinkIntensity;
  label?: string;
  description?: string;
  canvasId: string;
}

export interface UpdateLinkPayload {
  type?: LinkType;
  intensity?: LinkIntensity;
  label?: string;
  description?: string;
}

export const LINK_TYPE_COLORS: Record<LinkType, string> = {
  [LinkType.Hierarchy]: '#1E293B',
  [LinkType.Contribution]: '#22C55E',
  [LinkType.Contradiction]: '#EF4444',
  [LinkType.Complementarity]: '#3B82F6',
  [LinkType.Dependency]: '#9CA3AF',
  [LinkType.FreeForm]: '#9CA3AF',
};
